import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useKeyboardOpen } from '@/hooks'
import { useAppStore } from '@/store/useAppStore'
import { ROUTES } from '@shared/config/routes'
import { BottomMenuItem } from './BottomMenuItem'
import { MENU_ITEMS } from './menuItems'
import './BottomMenu.css'

const isActive = (path: string, pathname: string) =>
  path === ROUTES.HOME ? pathname === ROUTES.HOME : pathname.startsWith(path)

/** Нижнее меню: плавающая панель, подсветка переезжает к активному разделу. */
const BottomMenu = () => {
  const location = useLocation()
  // Пока открыта клавиатура, панель убираем вниз: iOS считает position: fixed
  // от видимой области, и меню всплывало бы над клавиатурой поверх поля ввода.
  const isKeyboardOpen = useKeyboardOpen()
  const hasSubscription = useAppStore(s => s.subscription.isActive)

  const activeIndex = MENU_ITEMS.findIndex(item =>
    isActive(item.path, location.pathname)
  )
  // На страницах вне меню (вкусы, пересчёт формы) подсветку прячем, но
  // оставляем на месте: иначе при возврате она приезжала бы из угла.
  const lastIndexRef = useRef(Math.max(activeIndex, 0))
  if (activeIndex >= 0) lastIndexRef.current = activeIndex

  // Первый кадр рисуем без перехода: иначе при открытии приложения подсветка
  // проезжала бы от первого пункта к текущему.
  const [isAnimated, setIsAnimated] = useState(false)
  useEffect(() => setIsAnimated(true), [])

  return (
    <div className={`block-bottom-menu ${isKeyboardOpen ? 'hidden' : ''}`}>
      <nav className="bottom-menu">
        <span
          className={`bottom-menu-pill ${isAnimated ? 'animated' : ''}`}
          style={{
            width: `${100 / MENU_ITEMS.length}%`,
            transform: `translateX(${lastIndexRef.current * 100}%)`,
            opacity: activeIndex >= 0 ? 1 : 0,
          }}
          aria-hidden
        />

        {MENU_ITEMS.map((item, index) => (
          <BottomMenuItem
            key={item.path}
            item={item}
            isActive={index === activeIndex}
            isLocked={Boolean(item.requiresSubscription) && !hasSubscription}
            lockedTo={ROUTES.SUBSCRIBE}
          />
        ))}
      </nav>
    </div>
  )
}

export default BottomMenu
